import React, { useEffect, useState } from 'react';
import s from './StickyLeadButton.module.css';

export default function StickyLeadButton({ onClick }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById('sketch-to-real');
    const update = () => {
      if (!target) {
        setVisible(window.scrollY > window.innerHeight * 1.2);
        return;
      }
      const rect = target.getBoundingClientRect();
      setVisible(rect.bottom <= 0);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <button
      type="button"
      className={`${s.button} ${visible ? s.visible : ''}`}
      onClick={onClick}
      aria-label="לשיחת היכרות לחצו כאן"
    >
      <span className={s.ring} />
      <span className={s.inner}>
        <span className={s.label}>לשיחת היכרות לחצו כאן</span>
        <span className={s.arrow} aria-hidden="true">←</span>
      </span>
    </button>
  );
}
